import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import ReactTable from "react-table";
import Button from "../../components/CustomButtons/Button.jsx";
import { Link as RouterLink } from "react-router-dom";
import DeleteConfirmationModal from "../../components/User/DeleteConfirmationModal.js";
import AddBoxIcon from '@material-ui/icons/AddBox';
import NewProjectModal from "../../components/User/NewFileModal.js";
import ProjectModal from "../../components/User/ProjectModal.js";
import LoaderComponent from '../../components/Loader';
import CustomSelect from "../../components/CustomInput/CustomSelect";
import LayersIcon from '@material-ui/icons/Layers';
import moment from 'moment';
import TextractFileModal from '../../components/User/TextractFileModal.js';
import RefreshIcon from "@material-ui/icons/Refresh";

const TextractProjects = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        this.state = {
            projects: [],
            fileId: null,
            deleteingResult: false,
            deleteModal: false,
            limit: 200,
            loading: false,
            page: 1,
            totalPages: 1,
            loadingMore: false,
            response: null,
            loadingProjects: false,
            project: '',
            creatingProject: false,
            newProjectModal: false,
            newProjectError: false,
            newProjectErrorMessage: null,
            savingDefaultProject: false,
            defaultProjectModal: false,
            defaultProjectError: false,
            defaultProjectErrorMessage: null,
            deletingProject: false,
            deleteProjectModal: false,
            deleteProjectError: false,
            deleteProjectErrorMessage: null,
            creditStats: {
                form: 0,
                receipt: 0,
                table: 0,
                text: 0
            },
            fileModal: false,
            previewFile: null,
        }

        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }
        this.loadProjects();
    }
    onNewProjectModal(status = false){
        this.setState({
            newProjectError: false,
            newProjectErrorMessage: null,
            newProjectModal: status,
        });
    }
    onNewProjectModalSuccess(projectName){
        const source = axios.CancelToken.source();
        this.setState({
            creatingProject: true,
            cancelToken: source,
        });

        const requestData = {
            name: projectName,
        }
        Api.addNewProject(requestData, source).then(data => {
            this.setState({
                creatingProject: false,
                newProjectModal: false,
                newProjectError: false,
                newProjectErrorMessage: null,
                projects: [
                    ...this.state.projects,
                    data.project
                ]
            });
        }).catch(err => {
            console.log(err);
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    creatingProject: false,
                    newProjectErrorMessage: err.message,
                    newProjectError: true,
                    cancelToken: null
                });
            }
        });
    }
    onDefaultProjectModal(status = false){
        this.setState({
            defaultProjectError: false,
            defaultProjectErrorMessage: null,
            defaultProjectModal: status,
        });
    }
    onDefaultProjectModalSuccess(project){
        const source = axios.CancelToken.source();
        this.setState({
            savingDefaultProject: true,
            cancelToken: source,
        });

        const requestData = {
            id: project,
        }
        Api.defaultProject(requestData, source).then(data => {
            const updatedProjects = this.state.projects.map(p => ({
                ...p,
                default: 0
            }));
            const existsIndex = updatedProjects.findIndex(p => p.id === data.project.id);
            updatedProjects[existsIndex] = {
                ...updatedProjects[existsIndex],
                ...data.project,
                default: 1
            };
            
            this.setState({
                savingDefaultProject: false,
                defaultProjectModal: false,
                defaultProjectError: false,
                defaultProjectErrorMessage: null,
                projects: updatedProjects,
                project: data.project.id
            },() => {
                this.loadResults()
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    savingDefaultProject: false,
                    defaultProjectError: true,
                    defaultProjectErrorMessage: err.message,
                    cancelToken: null
                });
            }
        });
    }
    onDeleteProjectModal(status = false){
        this.setState({
            deleteProjectError: false,
            deleteProjectErrorMessage: null,
            deleteProjectModal: status,
        });
    }
    onDeleteProjectModalSuccess(project){
        const source = axios.CancelToken.source();
        this.setState({
            deletingProject: true,
            cancelToken: source,
        });

        Api.deleteProject(project).then(data => {
            let newProjectId = this.state.project;
            if (this.state.project === project) {
                newProjectId = "all";
            }

            this.setState({
                deleteProjectModal: false,
                deletingProject: false,
                deleteProjectError: false,
                deleteProjectErrorMessage: null,
                projects: this.state.projects.filter(p => p.id !== project),
                project: newProjectId
            },() => {
                if(newProjectId === 'all'){
                    this.loadResults();
                }
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    deletingProject: false,
                    deleteProjectError: true,
                    deleteProjectErrorMessage: err.message,
                    cancelToken: null
                });
            }
        });
    }
    loadProjects(){
        const source = axios.CancelToken.source();
        
        this.setState({
            loadingProjects: true, 
            cancelToken: source,
        });

        let requestData = {};
        
        Api.getProjects(requestData, source).then(data => {
            const projects = [
                { id: 'all', name: 'All Projects' },
                ...(data.projects || [])
            ];
            const defaultProject = (data.projects || []).find(p => p.default === 1);

            this.setState({
                projects: projects,
                loadingProjects: false,
                project: defaultProject ? defaultProject.id : ''
            },() => {
                this.loadResults();
            });
        }).catch(err => {
            console.log(err);
        });
    }
    handleChange(event, name) {
        let value = event.target.value;

        this.setState({
            [name]: value
        },() => {
            this.loadResults();
        });
    }
    getTrProps(state, rowInfo){
        return {}
    }
    getTrGroupProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getColumns(){
        let columns = [
            
            {
                Header: "Created On",
                accessor: "created_at",
                headerClassName: "hd_creation_date",
                className: "hd_creation_date td_creation_date",
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if(a1<b1)
                    return 1;
                    else if(a1>b1)
                    return -1;
                    else
                    return 0;
                }
            },
            {
                Header: "Project Name",
                accessor: "project_name",
                headerClassName: "hd_name",
                className: "hd_name td_name",
            },
            {
                Header: "File Name",
                accessor: "file_name",
                headerClassName: "hd_name",
                className: "hd_name td_name",
            },
            {
                Header: "Language",
                accessor: "language",
                headerClassName: "hd_language",
                className: "hd_language td_language",
            },
            {
                Header: "Status",
                accessor: "status",
                headerClassName: "hd_status",
                className: "hd_status td_status",
            },
            {
                Header: "Format",
                accessor: "format",
                headerClassName: "hd_format",
                className: "hd_format td_format",
            },
            {
                Header: 'Pages',
                accessor: 'pages',
                headerClassName: 'hd_pages',
                className: 'hd_pages td_pages',
            },
            {
                Header: 'Task Type',
                accessor: 'type',
                headerClassName: 'hd_task_type',
                className: 'hd_task_type td_task_type',
            },
            {
                Header: "",
                accessor: "actions",
                headerClassName: "hd_actions",
                className: "hd_actions td_actions",
            }
        ]

        return columns;
    }
    getTableData(){
        const { response } = this.state;
        if(response === null){
            return [];
        }
        let tableData = [];
        
        response.map(file => {
            let fileArray = {
                id: file.id,
                created_at: this.getFormatedDate(file.created_at),
                project_name: file.project_name,
                file_name: file.file_name,
                language: this.getLanguageName(file.language),
                status: (
                    <span className={file.status}>{ file.status_value }</span>
                ),
                format: file.format,
                pages: file.pages,
                type: this.getTypeText(file.type),
                actions: (
                    <div>
                        <Button justIcon color="transparent" title={"Preview File"} onClick={() => this.onFileModal(true, file)}>
                            {
                                file.format === 'pdf' ?
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 2.5C0 1.12109 1.15726 0 2.58065 0H9.03226V5C9.03226 5.69141 9.60887 6.25 10.3226 6.25H15.4839V11.875H7.09677C5.67339 11.875 4.51613 12.9961 4.51613 14.375V20H2.58065C1.15726 20 0 18.8789 0 17.5V2.5ZM15.4839 5H10.3226V0L15.4839 5ZM7.09677 13.75H8.3871C9.63306 13.75 10.6452 14.7305 10.6452 15.9375C10.6452 17.1445 9.63306 18.125 8.3871 18.125H7.74194V19.375C7.74194 19.7188 7.45161 20 7.09677 20C6.74194 20 6.45161 19.7188 6.45161 19.375V17.5V14.375C6.45161 14.0312 6.74194 13.75 7.09677 13.75ZM8.3871 16.875C8.92339 16.875 9.35484 16.457 9.35484 15.9375C9.35484 15.418 8.92339 15 8.3871 15H7.74194V16.875H8.3871ZM12.2581 13.75H13.5484C14.6169 13.75 15.4839 14.5898 15.4839 15.625V18.125C15.4839 19.1602 14.6169 20 13.5484 20H12.2581C11.9032 20 11.6129 19.7188 11.6129 19.375V14.375C11.6129 14.0312 11.9032 13.75 12.2581 13.75ZM13.5484 18.75C13.9032 18.75 14.1935 18.4688 14.1935 18.125V15.625C14.1935 15.2812 13.9032 15 13.5484 15H12.9032V18.75H13.5484ZM16.7742 14.375C16.7742 14.0312 17.0645 13.75 17.4194 13.75H19.3548C19.7097 13.75 20 14.0312 20 14.375C20 14.7188 19.7097 15 19.3548 15H18.0645V16.25H19.3548C19.7097 16.25 20 16.5312 20 16.875C20 17.2188 19.7097 17.5 19.3548 17.5H18.0645V19.375C18.0645 19.7188 17.7742 20 17.4194 20C17.0645 20 16.7742 19.7188 16.7742 19.375V16.875V14.375Z"/>
                                    </svg>
                                :
                                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM2.5 10C2.5 9.66848 2.6317 9.35054 2.86612 9.11612C3.10054 8.8817 3.41848 8.75 3.75 8.75C4.08152 8.75 4.39946 8.8817 4.63388 9.11612C4.8683 9.35054 5 9.66848 5 10C5 10.3315 4.8683 10.6495 4.63388 10.8839C4.39946 11.1183 4.08152 11.25 3.75 11.25C3.41848 11.25 3.10054 11.1183 2.86612 10.8839C2.6317 10.6495 2.5 10.3315 2.5 10ZM8.4375 11.25C8.64453 11.25 8.83594 11.3516 8.95312 11.5195L12.3906 16.5195C12.5234 16.7109 12.5352 16.9609 12.4297 17.1641C12.3242 17.3672 12.1094 17.5 11.875 17.5H8.4375H6.875H5H3.125C2.89844 17.5 2.69141 17.3789 2.58203 17.1836C2.47266 16.9883 2.47266 16.7461 2.58984 16.5547L4.46484 13.4297C4.57812 13.2422 4.78125 13.125 5 13.125C5.21875 13.125 5.42188 13.2383 5.53516 13.4297L6.03516 14.2656L7.92188 11.5234C8.03906 11.3555 8.23047 11.2539 8.4375 11.2539V11.25Z"/>
                                    </svg>
                            }
                        </Button>
                        <Button justIcon color="transparent" title={"Download File"} onClick={() => this.downloadFile(file)}>
                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7723 7.70977L8.27227 12.2098C8.0543 12.4277 7.6957 12.4277 7.47773 12.2098L2.97773 7.70977C2.75977 7.4918 2.75977 7.1332 2.97773 6.91523C3.1957 6.69727 3.5543 6.69727 3.77227 6.91523L7.3125 10.4555V0.5625C7.3125 0.253125 7.56563 0 7.875 0C8.18437 0 8.4375 0.253125 8.4375 0.5625V10.4555L11.9777 6.91523C12.1957 6.69727 12.5543 6.69727 12.7723 6.91523C12.9902 7.1332 12.9902 7.4918 12.7723 7.70977ZM1.125 11.8125V15.1875C1.125 16.1191 1.88086 16.875 2.8125 16.875H12.9375C13.8691 16.875 14.625 16.1191 14.625 15.1875V11.8125C14.625 11.5031 14.8781 11.25 15.1875 11.25C15.4969 11.25 15.75 11.5031 15.75 11.8125V15.1875C15.75 16.7414 14.4914 18 12.9375 18H2.8125C1.25859 18 0 16.7414 0 15.1875V11.8125C0 11.5031 0.253125 11.25 0.5625 11.25C0.871875 11.25 1.125 11.5031 1.125 11.8125Z"/>
                            </svg>
                        </Button>
                        <RouterLink to={"/user/textract/result/"+file.id}>
                            <Button justIcon color="transparent" title={"View Textract Result"}>
                                <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM4.375 10H10.625C10.9688 10 11.25 10.2812 11.25 10.625C11.25 10.9688 10.9688 11.25 10.625 11.25H4.375C4.03125 11.25 3.75 10.9688 3.75 10.625C3.75 10.2812 4.03125 10 4.375 10ZM4.375 12.5H10.625C10.9688 12.5 11.25 12.7812 11.25 13.125C11.25 13.4688 10.9688 13.75 10.625 13.75H4.375C4.03125 13.75 3.75 13.4688 3.75 13.125C3.75 12.7812 4.03125 12.5 4.375 12.5ZM4.375 15H10.625C10.9688 15 11.25 15.2812 11.25 15.625C11.25 15.9688 10.9688 16.25 10.625 16.25H4.375C4.03125 16.25 3.75 15.9688 3.75 15.625C3.75 15.2812 4.03125 15 4.375 15Z"/>
                                </svg>
                            </Button>
                        </RouterLink>
                        <Button justIcon color="transparent" onClick={() => this.onDeleteResultModal(true, file.id)} title={"Delete"}>
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.94141 1.25H10.5547C10.7695 1.25 10.9688 1.35938 11.0859 1.54297L11.6836 2.5H5.81641L6.41406 1.54297C6.52734 1.35938 6.73047 1.25 6.94531 1.25H6.94141ZM13.1602 2.5L12.1484 0.882812C11.8047 0.332031 11.2031 0 10.5586 0H6.94141C6.29688 0 5.69531 0.332031 5.35156 0.882812L4.33984 2.5H2.50391H1.25H0.625C0.28125 2.5 0 2.78125 0 3.125C0 3.46875 0.28125 3.75 0.625 3.75H1.33984L2.33594 17.6797C2.42578 18.9883 3.51562 20 4.82812 20H12.6719C13.9844 20 15.0703 18.9883 15.1641 17.6797L16.1602 3.75H16.875C17.2188 3.75 17.5 3.46875 17.5 3.125C17.5 2.78125 17.2188 2.5 16.875 2.5H16.25H14.9961H13.1602ZM14.9102 3.75L13.918 17.5898C13.8711 18.2422 13.3281 18.75 12.6719 18.75H4.82812C4.17188 18.75 3.62891 18.2422 3.58203 17.5898L2.59375 3.75H14.9062H14.9102Z"/>
                            </svg>
                        </Button>
                    </div>
                ),
            };
            tableData.push(fileArray);
            return null;
        });
        return tableData;
    }
    getTypeText(type){
        let value = '';

        switch (type) {
            case "text":
                value = "Text Detection";
                break;
            case "form":
                value = "Form Analysis";
                break;
            case "table":
                value = "Table Analysis";
                break;
            case "receipt":
                value = "Receipt Analysis";
                break;
            default:
                value = "";
                break;
        }

        return value;
    }
    async downloadFile(file){
        if (!file.file_url) return;

        try {
            const response = await fetch(file.file_url, { method: 'GET' });
            const blob = await response.blob();

            const fileName = file.file_name || 'download';
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error('Download failed:', error);
        }
    }
    getFormatedDate(date){
        if(!date || date.length <= 0){
            return "";
        }
        return moment(date).format("MM/DD/YYYY HH:mm:ss");
    }
    onFileModal(status = false, file = null){
        this.setState({
            fileModal: status,
            previewFile: file
        })
    }
    loadResults(viewMore = false){
        const source = axios.CancelToken.source();
        
        let { page } = this.state;
        if(viewMore){
            page += 1;
        }else{
            page = 1;
        }

        this.setState({
            page: page,
            loading: (!viewMore), 
            loadingMore: viewMore,
            cancelToken: source,
        });

        let requestData = {
            page: page,
            limit: 200,
            project_id: this.state.project
        };
        
        Api.getResults(requestData, source).then(data => {
            const oldResponse = (viewMore ? this.state.response:[]);
            const response = oldResponse.concat(data.response);

            this.setState({
                response: response,
                loading: false,
                loadingMore: false,
                totalPages: data.totalPages,
                creditStats: data.credits,
                cancelToken: null
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    loadingMore: false,
                    cancelToken: null
                })
            }
        });
    }
    getLanguageOptions(){
        return [
            {
                key: 'en-US',
                value: 'English'
            },
            {
                key: 'fr-FR',
                value: 'French'
            },
            {
                key: 'de-DE',
                value: 'German'
            },
            {
                key: 'it-IT',
                value: 'Italian',
            },
            {
                key: 'pt-PT',
                value: 'Portuguese',
            },
            {
                key: 'es-ES',
                value: 'Spanish'
            },
        ]
    }
    getLanguageName(language){
        const option = this.getLanguageOptions().find(opt => opt.key === language);
        return option ? option.value : language;
    }
    onDeleteResultModal(status = true, fileId = null){
        if(fileId === null && status === true){
            return;
        }
        this.setState({
            deleteModal: status,
            fileId: fileId
        });
    }
    onDeleteResultModalSuccess(){
        const { fileId } = this.state;

        const source = axios.CancelToken.source();

        this.setState({
            deleteingResult: true
        })
        
        Api.deleteResult(fileId, source).then(data => {
            this.setState({
                response: this.state.response.filter(p => p.id !== fileId),
                deleteModal: false,
                fileId: null,
                deleteingResult: false,
            });
        }).catch(err => {
            //Handle Error
        });
    }
    render() {
        const { classes } = this.props;
        const { limit, deleteModal, project, projects, loadingProjects, newProjectError, newProjectErrorMessage,
            newProjectModal, creatingProject, defaultProjectError, defaultProjectErrorMessage, savingDefaultProject, 
            defaultProjectModal, deletingProject, deleteProjectError, deleteProjectErrorMessage, deleteProjectModal, 
            loading, creditStats, deleteingResult, fileModal, previewFile, totalPages, loadingMore, page } = this.state;
        const { authorized } = this.store.getState();
        const tableData = this.getTableData();
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.textractMainContainer}>
                    <div className={classes.content}>
                        <GridItem>
                            <div className={classes.textractContainer}>
                                <h3 className={classes.title}>My Textract Projects</h3>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <div className='tasks-section'>
                                            <div className='header-section'>
                                                <h5>All My Textract Projects</h5>
                                            </div>
                                            <div className='filter-section'>
                                                <div className='project-select-create'>
                                                    {
                                                        projects.length > 0 ?
                                                            <>
                                                                <CustomSelect 
                                                                    formControlProps={{
                                                                        fullWidth: true,
                                                                        className: 'custom-input body m-zero'
                                                                    }}
                                                                    labelText="Select Project Name"
                                                                    selectProps={{
                                                                        onChange: (e) => this.handleChange(e,"project"),
                                                                        value: project,
                                                                    }}
                                                                    inputProps={{
                                                                        name: "project",
                                                                        id: "input-project",
                                                                        className: classes.alignLeft,
                                                                    }}
                                                                    items={projects}
                                                                    itemLabel="name"
                                                                    itemValue="id"
                                                                    color="custom"
                                                                />
                                                                <Button justIcon color="custom" onClick={() => this.onNewProjectModal(true) } className='create-project-btn' title="Create New Project">
                                                                    <AddBoxIcon />
                                                                </Button>
                                                                <Button justIcon color="custom" onClick={() => this.onDefaultProjectModal(true) } className='create-project-btn' title="Set Default Project">
                                                                    <LayersIcon />
                                                                </Button>
                                                                <Button justIcon color="custom" onClick={() => this.onDeleteProjectModal(true) } className='create-project-btn' title="Delete Project">
                                                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M6.94141 1.25H10.5547C10.7695 1.25 10.9688 1.35938 11.0859 1.54297L11.6836 2.5H5.81641L6.41406 1.54297C6.52734 1.35938 6.73047 1.25 6.94531 1.25H6.94141ZM13.1602 2.5L12.1484 0.882812C11.8047 0.332031 11.2031 0 10.5586 0H6.94141C6.29688 0 5.69531 0.332031 5.35156 0.882812L4.33984 2.5H2.50391H1.25H0.625C0.28125 2.5 0 2.78125 0 3.125C0 3.46875 0.28125 3.75 0.625 3.75H1.33984L2.33594 17.6797C2.42578 18.9883 3.51562 20 4.82812 20H12.6719C13.9844 20 15.0703 18.9883 15.1641 17.6797L16.1602 3.75H16.875C17.2188 3.75 17.5 3.46875 17.5 3.125C17.5 2.78125 17.2188 2.5 16.875 2.5H16.25H14.9961H13.1602ZM14.9102 3.75L13.918 17.5898C13.8711 18.2422 13.3281 18.75 12.6719 18.75H4.82812C4.17188 18.75 3.62891 18.2422 3.58203 17.5898L2.59375 3.75H14.9062H14.9102Z"/>
                                                                    </svg>
                                                                </Button>
                                                            </>
                                                        :
                                                            loadingProjects ?
                                                                <LoaderComponent color="custom" align="left" />
                                                            :
                                                                <></>
                                                    }
                                                </div>
                                                <div className='filter-stats'>
                                                    <span>Total Text Pages: {creditStats.text}</span>
                                                    <span>Total Form Pages: {creditStats.form}</span>
                                                    <span>Total Table Pages: {creditStats.table}</span>
                                                    <span>Total Receipt Pages: {creditStats.receipt}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <div className='tasks-section'>
                                            <div className='tasks-table'>
                                                <ReactTable
                                                    columns={this.getColumns()}
                                                    data={tableData}
                                                    pageSizeOptions={[500]}
                                                    defaultPageSize={limit}
                                                    showPaginationTop={false}
                                                    minRows={0}
                                                    showPaginationBottom={false}
                                                    className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable}
                                                    getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                                    getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                                    getNoDataProps={() => this.getNoDataProps()}
                                                />
                                                {
                                                    loading ?
                                                        <LoaderComponent color="custom" align="center" />
                                                    :
                                                        <></>
                                                }
                                                <div className={classes.loadMore}>
                                                    {
                                                        tableData.length > 0 && loadingMore === false && page < totalPages ?
                                                            <Button color="custom" id="contentViewMore" onClick={(e) => this.loadResults(true)}>
                                                                <RefreshIcon className={classes.icons} />View More
                                                            </Button>
                                                        :
                                                            loadingMore === true ?
                                                                <LoaderComponent color="custom" align="center" />
                                                            :
                                                                <></>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </div>
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
                {
                    deleteModal ?
                        <DeleteConfirmationModal
                            confirmationMessage="Do you want to delete this textract result?"
                            open={deleteModal}
                            onClose={() => this.onDeleteResultModal(false)}
                            onSuccess={() => this.onDeleteResultModalSuccess()}
                            saving={deleteingResult}
                        />
                    :
                        <></>
                }
                {
                    newProjectModal ?
                        <NewProjectModal
                            open={newProjectModal}
                            saving={creatingProject}
                            store={this.store} 
                            onClose={() => this.onNewProjectModal(false)}
                            onSuccess={(projectName) => this.onNewProjectModalSuccess(projectName)}
                            confirmationMessage="Create New Project"
                            error={newProjectError}
                            errorMessage={newProjectErrorMessage}
                            inputLabel="Project Name"
                        />
                    :
                        <></>
                }
                {
                    defaultProjectModal ?
                        <ProjectModal
                            open={defaultProjectModal}
                            saving={savingDefaultProject}
                            store={this.store} 
                            onClose={() => this.onDefaultProjectModal(false)}
                            onSuccess={(project) => this.onDefaultProjectModalSuccess(project)}
                            title="Select Default Project"
                            inputLabel="Select Default Project"
                            error={defaultProjectError}
                            errorMessage={defaultProjectErrorMessage}
                            projects={projects}
                        />
                    :
                        <></>
                }
                {
                    deleteProjectModal ?
                        <ProjectModal
                            open={deleteProjectModal}
                            saving={deletingProject}
                            store={this.store} 
                            onClose={() => this.onDeleteProjectModal(false)}
                            onSuccess={(project) => this.onDeleteProjectModalSuccess(project)}
                            title="Delete Project"
                            inputLabel="Select Project to Delete"
                            error={deleteProjectError}
                            errorMessage={deleteProjectErrorMessage}
                            projects={projects}
                            buttonText={"Delete"}
                        />
                    :
                        <></>
                }
                {
                    fileModal ?
                        <TextractFileModal
                            open={fileModal}
                            onClose={() => this.onFileModal(false)}
                            file={previewFile}
                        />
                    :
                        <></>
                }
            </div>
        )
    }
}

TextractProjects.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(TextractProjects);
